import { useFrame } from '@react-three/fiber'
import { easing } from 'maath'
import { useSnapshot } from 'valtio'
import { state } from '../../../context/store'


const MainSeat = ({ children, nodes, materials }) => {

    const snap = useSnapshot(state.current)

    useFrame((state, delta) => {
        easing.dampC(materials.TopPanel.color, snap.choices.topPanel.selected.hex, 0.1, delta)
        easing.dampC(materials.SidePanels.color, snap.choices.sidePanels.selected.hex, 0.1, delta)
        easing.dampC(materials.BottomPanel.color, '#000', 0.1, delta)
    })

    return (
        <group dispose={null}>

            <mesh
                castShadow
                receiveShadow
                geometry={nodes.Mesh.geometry}
                material={materials.TopPanel}
                material-envMapIntensity={1.3}
                material-roughness={0.5}
                material-metalness={0.0}
            >
                {children}
            </mesh>

            <mesh
                castShadow
                receiveShadow
                geometry={nodes.Mesh_1.geometry}
                material={materials.SidePanels}
                material-envMapIntensity={0.3}
                material-roughness={0.5}
                material-metalness={0.0}
            />
            <mesh
                castShadow
                receiveShadow
                geometry={nodes.Mesh_2.geometry}
                material={materials.BottomPanel}
            />

        </group>
    )
}

export default MainSeat